// React
import React, {
    useRef,
    useEffect
} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// Facade
import Facade from 'core/Facade';
// Style
import { useStyles } from 'components/tables/PerformancesTable/PerformancesTable.style';
// Util
import { formatData } from 'components/tables/PerformancesTable/PerformancesTable.util';
// Material UI
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DownArrowIcon from '@mui/icons-material/CallReceived';
import UpArrowIcon from '@mui/icons-material/CallMade';

const PerformancesTable = ({ sites, openManagePerformanceDialog, to, from }) => {
    const tableEnd = useRef(null);
    const classes = useStyles();

    const scrollToBottom = () => {
        tableEnd.current && tableEnd.current.scrollIntoView({ behavior: 'auto' });
    };

    useEffect(scrollToBottom, [sites]);

    if (sites.length === 0)
        return null;

    return (
        <Paper className={classes.root} id='performances-table'>
            <Table className={classes.table} aria-labelledby='performances-table' stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.tableHeadCell}>Date</TableCell>
                        {sites.map((site, key) => <TableCell key={key} align='center' className={classes.tableHeadCell}>{Facade.siteDisplayName(site.name)}</TableCell>)}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {formatData(sites).map((performance, key) =>
                        <TableRow
                            hover
                            key={key}
                        >
                            <TableCell key={key}>{Facade.formatDate(new Date(performance.date))}</TableCell>
                            {sites.map((site, index) => {
                                if (performance[site.name])
                                    return <TableCell key={index} align='center'>{performance[site.name].orderCount}<IconButton aria-label='delete' onClick={() => openManagePerformanceDialog({
                                        orderCount: performance[site.name].orderCount,
                                        siteId: site.id,
                                        performanceId: performance[site.name].id,
                                        date: new Date(performance.date)
                                    })}>
                                        <EditIcon fontSize='small' />
                                    </IconButton></TableCell>;
                                return <TableCell key={index} align='center'>-<IconButton aria-label='delete' onClick={() => openManagePerformanceDialog({
                                    orderCount: 0,
                                    siteId: site.id,
                                    performanceId: null,
                                    date: new Date(performance.date)
                                })}>
                                    <EditIcon fontSize='small' />
                                </IconButton></TableCell>;
                            })}
                        </TableRow>)}
                    <TableRow hover>
                        <TableCell className={classNames(classes.tableBottomCell, classes.leftCell)} title={'Evolution: ' + Facade.formatDate(from) + ' - ' + Facade.formatDate(to)}>{'Evolution: ' + Facade.formatDate(from) + ' - ' + Facade.formatDate(to)}</TableCell>
                        {sites.map((site, key) => {
                            if (!site.records[site.records.length - 1])
                                return (
                                    <TableCell key={key} align='center' className={classes.tableBottomCell}>
                                        -
                                    </TableCell>
                                );

                            const value = ((site.records[site.records.length - 1].orderCount / site.records[0].orderCount) - 1) * 100;
                            return (
                                <TableCell key={key} align='center' className={classes.tableBottomCell}>
                                    {value.toFixed(0) + '%'}
                                    {value < 0 ?
                                        <DownArrowIcon className={classNames(classes.bottomCellIcon, classes.redIcon)} />
                                        :
                                        <UpArrowIcon className={classNames(classes.bottomCellIcon, classes.greenIcon, value === 0 && classes.hide)} />
                                    }
                                </TableCell>
                            );
                        })}
                    </TableRow>
                    <TableRow ref={tableEnd} />
                </TableBody>
            </Table>
        </Paper >
    );
};

PerformancesTable.propTypes = {
    sites: PropTypes.array,
    openManagePerformanceDialog: PropTypes.func,
    to: PropTypes.any,
    from: PropTypes.any
};

export default PerformancesTable;
